import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  DelegationBasicInfo,
  DelegationContactInfo,
  DelegationFileUpload,
  DelegationFormActions,
} from "../../components/forms/DelegationForm";

interface EditOutgoingDelegationProps {}

const EditOutgoingDelegation: React.FC<EditOutgoingDelegationProps> = () => {
  const navigate = useNavigate();

  // Get ID from URL path
  const getDelegationId = () => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[pathParts.length - 1];
  };

  const id = getDelegationId();

  const [formData, setFormData] = useState({
    country: "",
    organization: "",
    fromDate: "",
    toDate: "",
    quarter: "",
    delegationName: "",
    budget: "",
    budgetSource: "",
    receivingUnit: "",
    purpose: "",
    otherPurpose: "",
    basis: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  // Mock data for editing - in real app, this would come from API
  const mockDelegationData = {
    country: "Nhật Bản",
    organization: "Tổ chức 2",
    fromDate: "2023-04-15",
    toDate: "2023-04-25",
    quarter: "Q2",
    delegationName: "Đoàn ra 1",
    budget: "120000000",
    budgetSource: "Ngân sách nhà nước",
    receivingUnit: "Phòng Hợp tác quốc tế",
    purpose: "Tham gia hội thảo khoa học",
    otherPurpose: "",
    basis: "Thỏa thuận hợp tác",
    notes: "Đoàn công tác",
    attachedFiles: [] as File[],
  };

  useEffect(() => {
    // Load delegation data for editing
    if (id) {
      // In real app, fetch data from API based on id
      setFormData(mockDelegationData);
    }
  }, [id]);

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Updating outgoing delegation data:", formData);
    // TODO: Implement update functionality
    // After successful update, navigate back to delegation list
    navigate("/outgoing-delegations");
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Sửa Đoàn ra">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">Sửa Đoàn ra</h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <DelegationBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <DelegationContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <DelegationFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <DelegationFormActions onSave={handleSave} onCancel={handleCancel} />
      </div>
    </PageShell>
  );
};

export default EditOutgoingDelegation;
